import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);
const store = new Vuex.Store({
  state: {
    ids: [],
    clickIds: [],
    collect: null,
    mycollect: null
  },
  mutations: {
    setIds(state, payload) {
      state.ids = payload;
    },
    setCollect(state, payload) {
      state.collect = payload;
    },
    setMyCollect(state, payload) {
      state.mycollect = payload;
    },
    setClickIds(state, payload) {
      let clickIds = state.clickIds;
      clickIds.push(payload);
      state.clickIds = [...new Set(clickIds)];
    }
  }
});
export default store;